import React, { useState } from 'react';
import { Card, Button, Alert } from 'react-bootstrap';

const EmbedTest: React.FC = () => {
  const testUrl = '/pay/TEST';
  const [copied, setCopied] = useState<boolean>(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(`${window.location.origin}${testUrl}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <Card>
            <Card.Header>
              <h4>Embed Link Test</h4>
            </Card.Header>
            <Card.Body>
              <Alert variant="info">
                <strong>Test Embed Link:</strong> This page demonstrates the embed functionality.
                The link below will open the TransFi payment gateway in an iframe.
              </Alert>
              
              <div className="mb-3">
                <label className="form-label">Test URL:</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={`${window.location.origin}${testUrl}`}
                    readOnly
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={copyToClipboard}
                  >
                    {copied ? 'Copied!' : 'Copy'}
                  </Button>
                </div>
              </div>

              <div className="d-grid gap-2">
                <Button
                  variant="primary"
                  href={testUrl}
                  target="_blank"
                >
                  Open Embed Page
                </Button>
              </div>

              <hr />

              <h5>Features:</h5>
              <ul>
                <li>Full-screen iframe embedding</li>
                <li>Responsive design</li>
                <li>Loading states</li>
                <li>Error handling</li>
                <li>Close button to return to dashboard</li>
                <li>Secure iframe sandboxing</li>
              </ul>

              <h5>Future Implementation:</h5>
              <ul>
                <li>API endpoint integration</li>
                <li>Dynamic URL generation</li>
                <li>User authentication</li>
                <li>Link management</li>
                <li>Analytics tracking</li>
              </ul>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default EmbedTest;
